export enum EMobileFilters {
  moreFilters = 'moreFilters',
  region = 'region',
  dates = 'dates',
  guests = 'guests',
  price = 'price',
  starRating = 'starRating',
  offerType = 'offerType',
}
